module.exports = __webpack_public_path__ + "img/chevron-down.555674a9.svg";